/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-props-no-spreading */

import PropTypes from 'prop-types';

import ImputationObjectModal from '../ImputationObjectModal/ImputationObjectModal';
import ModalProgramPointApproval from '../ApprovalPending/ViewApprovalPendingContainer/TableApproval/ModalProgramPointApproval/ModalProgramPointApproval';

import AttachFileModal from './AttachFileModal/AttachFileModal';
import TotalLineModal from './TotalLineModal/TotalLineModal';
import CommentsModal from './CommentsModal/CommentsModal';
import QuantityEntryModal from './QuantityEntryModal/QuantityEntryModal';
import MonthlySummaryModal from './MonthlySummaryModal/MonthlySummaryModal';
import RejectModal from './RejectModal/RejectModal';
import ApproveAllModal from './ApproveAllModal/ApproveAllModal';
import ExpertReviewModal from './ExpertReviewModal/ExpertReviewModal';
import InspectorExpertReviewModal from './InspectorExpertReviewModal/InspectorExpertReviewModal';
import EditQuantityModal from './EditQuantityModal/EditQuantityModal';
import ConfirmApprovalModal from './ConfirmApprovalModal/ConfirmApprovalModal';
import TemplateWorkReportModal from './TemplateWorkReportModal/TemplateWorkReportModal';
import EndServiceModal from './EndServiceModal/EndServiceModal';
import ImputationModal from './ImputationModal/ImputationModal';
import StatusReferenceModal from './StatusReferenceModal/StatusReferenceModal';
import NewValueImputationModal from './NewValueImputationModal/NewValueImputationModal';
import ApproveOrRejectSelectedQuantitiesModal from './ApproveOrRejectSelectedQuantitiesModal/ApproveOrRejectSelectedQuantitiesModal';
import ProgramPointModalFormik from './ProgramPointModal/ProgramPointModalFormik';

const WorkReportModals = ({ showModal, onHide, ...props }) => (
  <>
    <TotalLineModal onHide={onHide} show={showModal.totalLineModal} {...props} />

    <AttachFileModal onHide={onHide} show={showModal.attachFileModal} {...props} />

    <CommentsModal onHide={onHide} show={showModal.commentsModal} {...props} />

    <QuantityEntryModal onHide={onHide} show={showModal.quantityEntryModal} {...props} />

    <MonthlySummaryModal onHide={onHide} show={showModal.monthlySummaryModal} {...props} />

    <RejectModal onHide={onHide} show={showModal.rejectModal} {...props} />

    <ApproveAllModal onHide={onHide} show={showModal.approveAllModal} {...props} />

    <ExpertReviewModal onHide={onHide} show={showModal.expertReviewModal} {...props} />

    <ImputationModal onHide={onHide} show={showModal.modifyImputationModal} {...props} />

    <NewValueImputationModal
      onHide={onHide}
      show={showModal.modifyNewValueImputationModal}
      {...props}
    />

    <InspectorExpertReviewModal
      onHide={onHide}
      show={showModal.inspectorExpertReviewModal}
      {...props}
    />

    <EditQuantityModal onHide={onHide} show={showModal.editQuantityModal} {...props} />

    <ConfirmApprovalModal onHide={onHide} show={showModal.confirmApprovalModal} {...props} />

    <TemplateWorkReportModal onHide={onHide} show={showModal.templateWorkReportModal} {...props} />

    <EndServiceModal onHide={onHide} show={showModal.endServiceModal} {...props} />

    <StatusReferenceModal onHide={onHide} show={showModal.statusReferenceModal} {...props} />

    <ApproveOrRejectSelectedQuantitiesModal
      onHide={onHide}
      show={showModal.approveOrRejectSelectedQuantitiesModal}
      {...props}
    />

    <ProgramPointModalFormik onHide={onHide} show={showModal.programPointModal} {...props} />
    <ImputationObjectModal onHide={onHide} show={showModal.imputationObjectModal} {...props} />
    <ModalProgramPointApproval
      onHide={onHide}
      show={showModal.programPointApprovalModal}
      {...props}
    />
  </>
);

export default WorkReportModals;

WorkReportModals.propTypes = {
  showModal: PropTypes.objectOf(PropTypes.bool).isRequired,
  onHide: PropTypes.func
};

WorkReportModals.defaultProps = {
  onHide: () => {
    /* Empty */
  }
};
